import { createFileRoute } from "@tanstack/react-router";
import PrivateListingSuccess from "@/pages/PrivateListingSuccess";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/vinde-masina/success/")({
  head: () => routeHead("/de/vinde-masina/success/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateListingSuccess />
  );
}
